import Layout from '../../components/Layout/Main';
import Content from '../../components/Pages/Profile';
import { displayName } from '../../config';

const Profile = (): JSX.Element => {
  document.title = `${displayName}: My Profile`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default Profile;
